<!--地址管理 -->
<template>
  <div class="orderAddress" v-if="hideMask && orderAddressList && orderAddressList.length != 0">
    <h2 class="adressTitle">当前待发货讲义地址</h2>
    <div class="orderAddress-body">
      <order-adress-list ref="adresslistRef" :orderAddressList="orderAddressList" />
      <van-popup v-model="show" position="bottom" duration="0.17" round overlay-class="overlayClass"
        :close-on-click-overlay="false" close-on-popstate>
        <div class="addressListBody">
          <div class="addressDesc">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/address/orderaddresswarn.png" alt="">
            <span>当前您的讲义存在以下多个收货地址，为保证发货地址的准确性，请选择其中一个作为所有待发货讲义的地址～</span>
          </div>
          <order-adress-list ref="adresslistRef" @onClickChangeBgColor="onClickChangeBgColor"
            :orderAddressList="orderAddressList" type="popup" />
        </div>
        <div class="footer">
          <div class="addBtn btnCom" @click="onClickAddSubmit">去新增</div>
          <div :class="['submitBtn', 'btnCom', btnBgColor]" @click="onClickSubmitAddress">确定</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { reqOrderAddressList } from '@/api/personal/addressController/index'
import orderAdressList from './orderAdressList.vue'

import _ from 'lodash';
export default {
  props: {
    newAddressFlag: Boolean,
    delCheck: Boolean,
    chooseIndex: Number,
    oldChoose: Number,
  },
  data() {
    return {
      orderAddressList: [], // 地址列表
      scroll: 0,
      addressId: 0, // 地址id
      isActive: -1,
      show: false,
      btnBgColor: 'normalBtn', // 按钮颜色
      addressItemArr: null, // 当前选中地址的item
      parIndex: -1, // 默认值
      hideMask: false, // 从我的订单过来隐藏待发货区域
    };
  },

  components: {
    orderAdressList
  },

  watch: {
    chooseIndex(val) {
      this.parIndex = val;
    }
  },

  activated() {
    const _query = this.$route.query;
    if (_query?.isHideMask) {
      this.hideMask = false;
    } else if (Number(_query?.sourse) === 1) {
      this.hideMask = true;
    } else {
      this.hideMask = false;
    }
    if (this.hideMask) {
      this.getOrderAddressList();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.adresslistRef) this.$refs.adresslistRef.currentIndex = this.parIndex;
    })
  },
  methods: {
    // 去新增
    onClickAddSubmit() {
      this.show = false;
      this.handleDefault();
    },

    // 确定修改
    onClickSubmitAddress() {
      if (!this.addressItemArr) return
      const [, index, item] = this.addressItemArr
      this.$emit('chooseAddress', index, item, 'orderAddress');
    },

    // 获取地址列表
    async getOrderAddressList() {
      try {
        const res = await reqOrderAddressList();
        if (res?.code !== 0) {
          this.$toast('请求错误！')
          return false
        };
        const data = res?.data;
        data.map((item, index) => {
          item.userName = item.consignee;
          if (!item.province) {
            data.splice(index, 1)
          }
        })
        if (data?.length >= 2) this.show = true;
        this.orderAddressList = data
      } catch (error) {
        this.$toast(error.message);
      }
    },

    // 选择地址后按钮的颜色
    onClickChangeBgColor(num, index, item) {
      this.btnBgColor = num === -1 ? 'normalBtn' : 'activeBtn'
      this.addressItemArr = [num, index, item];
    },

    // 二次弹框取消
    onClickCancel() {
      if (this.orderAddressList.length < 2) return;
      this.handleDefault();
    },

    // 恢复默认状态
    handleDefault() {
      this.$refs.adresslistRef.currentIndex = -1;
      this.btnBgColor = 'normalBtn';
      this.addressItemArr = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.orderAddress {
  .adressTitle {
    margin: 28px 0 25px 36px;
    color: #787878;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }

  /* stylelint-disable */
  ::v-deep .van-swipe-cell__right {
    display: flex;
    align-items: center;
  }

  /* stylelint-enable */

  &-body {
    width: 100%;
    padding: 0 36px 20px;
    background: #f9f9f9ff;
    position: relative;

    .overlayClass {
      max-height: 820px;
      border-radius: 14px 14px 0px 0px;
    }

    .addressListBody {
      width: 750px;
      height: 660px;
      background: #FFFFFF;
      padding-bottom: 160px;

      .addressDesc {
        font-size: 22px;
        color: #FF6C02;
        padding: 36px;
        line-height: 31px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 29px;
          height: 29px;
          margin-right: 16px;
        }
      }
    }


    .adressList {
      position: absolute;
      bottom: 160px;
      left: 0;
    }

    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 11;
      width: 100%;
      height: 160px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 36px;

      .btnCom {
        width: 324px;
        height: 80px;
        border-radius: 45px;
        font-size: 33px;
        color: #FFFFFF;
        text-align: center;
        line-height: 80px;
      }

      .addBtn {
        border: 2px solid #FF6C02;
        color: #FF6000;
      }

      .activeBtn {
        background: #FF6C02;
      }

      .normalBtn {
        background: #A5A5A5;
      }
    }
  }
}
</style>
